"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeIconMenuLink = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var MenuItem_1 = tslib_1.__importDefault(require("@material-ui/core/MenuItem"));
var useStyles = styles_1.makeStyles({
    Wrap: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: 446,
        height: 40,
    },
    emojiWrap: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: 40,
        width: 28,
        marginLeft: 23,
    },
    emojiFont: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 35,
        height: 25,
        fontSize: 14,
        fontWeight: 500,
        marginTop: 8,
        textDecoration: "none",
        borderRadius: 3,
    },
    button: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: 80,
        height: 25,
        marginRight: 25,
    },
    buttonLeft: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 25,
        fontSize: 14,
        fontWeight: 400,
        borderRadius: 3,
    },
    buttonRight: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 25,
        fontSize: 14,
        fontWeight: 400,
        borderRadius: 3,
    },
});
function ChangeIconMenuLink(props) {
    var clickButton1 = props.clickButton1, clickButton2 = props.clickButton2;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.Wrap },
        React.createElement("div", { className: classes.emojiWrap },
            React.createElement("span", { className: classes.emojiFont }, "\u8868\u60C5")),
        React.createElement("div", { className: classes.button },
            React.createElement("div", null,
                React.createElement(MenuItem_1.default, { className: classes.buttonLeft },
                    React.createElement("div", { onClick: clickButton1 }, "\u968F\u673A"))),
            React.createElement("div", null,
                React.createElement(MenuItem_1.default, { className: classes.buttonRight },
                    React.createElement("div", { onClick: clickButton2 }, "\u79FB\u9664"))))));
}
exports.ChangeIconMenuLink = ChangeIconMenuLink;
//# sourceMappingURL=ChangeIconMenuLink.js.map